import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { salesPageData, salesFAQs } from "./salesdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForSaleForceManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Sales Force Automation — Triple Field Sales Productivity with AI"
        description="EkkBaz AI Sales Force Automation enables voice ordering, real-time pricing intelligence, and AI route planning — tripling rep productivity and achieving 99%+ order accuracy."
        keywords="sales force automation software, field sales automation, AI sales management, voice order entry, sales rep productivity, sales territory management"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/salesforce`}
        productName="Salesforce Automation"
        faqItems={salesFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Salesforce Automation"
        subtitle="Voice ordering, AI pricing intelligence, and smart route planning — giving your field sales team the power to close 3× more deals every day."
        from="salesforce"
      />
      <EnhancedPageLayout {...salesPageData} />
      <UpdateFooter />
    </div>
  );
}
